import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Stack, Typography } from "@mui/material";
import { FormikProps } from "formik";

import { CourtFormType } from "@/pages/system-settings/tabs/courts/vienna/components/court-dialog/court-form-fields/CourtForm.types";
import { emptyCourtDay } from "@/pages/system-settings/tabs/courts/vienna/components/court-dialog/court-form-fields/CourtForm.utils";
import { useTranslation } from "@/translations";

import { CourtDayRow } from "../court-day-row/CourtDayRow";

interface Props {
  formik: FormikProps<CourtFormType>;
}

export function CourtDaysEditor({ formik }: Props) {
  const { t } = useTranslation();
  const courtDays = formik.values.courtDays;

  const handleAdd = () => {
    void formik.setFieldValue("courtDays", [...courtDays, emptyCourtDay()]);
  };

  const handleRemove = (index: number) => {
    void formik.setFieldValue(
      "courtDays",
      courtDays.filter((_, i) => i !== index)
    );
  };

  return (
    <Stack gap={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h4">{t("settings.courts.gerichtstag.sectionTitle")}</Typography>
        <Button variant="outlined" startIcon={<AddIcon />} onClick={handleAdd}>
          {t("settings.courts.gerichtstag.add")}
        </Button>
      </Stack>

      {courtDays.length === 0 ? (
        <Typography color="text.secondary">{t("settings.courts.gerichtstag.empty")}</Typography>
      ) : (
        <Stack gap={2}>
          {courtDays.map((_, index) => (
            <CourtDayRow key={index} formik={formik} index={index} onRemove={() => handleRemove(index)} />
          ))}
        </Stack>
      )}

      <Box />
    </Stack>
  );
}
